import { Injectable } from '@angular/core';
import { HistoryContactSource } from '@history/core/cache/history-contact-source.service';
import { HistoryInteractionSource } from '@history/core/cache/history-interaction-source.service';
import { HistoryRouter } from '@history/history-router';
import { HistoryState } from '@history/history-routing.module';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { delay, tap, withLatestFrom } from 'rxjs';

import { CngBootstrapEffect, CustomerAction } from '@contact/upgrade';

import { CngHistoryEffect } from '../history.effect';

@Injectable()
export class HistorySystemProtectedEffect extends CngHistoryEffect {
  readonly refresh$ = this.actions$.pipe(
    ofType(
      CustomerAction.CreateSuccess,
      CustomerAction.ReplaceSuccess,
      CustomerAction.UpdateSuccess,
      CustomerAction.DeleteSuccess,
      CustomerAction.MergeSuccess,
      CustomerAction.ImportSuccess
    )
  );

  /**
   * Refresh contact source
   */
  readonly refreshContactSource$ = createEffect(
    () =>
      this.refresh$.pipe(
        delay(1000),
        withLatestFrom(this.router.currentUrl$, (_, url) => {
          const [path] = (url && url.split('/').reverse()) ?? [];
          return path;
        }),
        tap(path => {
          if (path === HistoryState.CONTACT) {
            this.historyContactSource.reload();
            return;
          }
          this.historyContactSource.reset();
        })
      ),
    { dispatch: false }
  );

  /**
   * Refresh interaction source
   */
  readonly refreshTinteractionSource$ = createEffect(
    () =>
      this.refresh$.pipe(
        delay(1000),
        withLatestFrom(this.router.currentUrl$, (_, url) => {
          const [path] = (url && url.split('/').reverse()) ?? [];
          return path;
        }),
        tap(path => {
          if (path === HistoryState.INTERACTION) {
            this.historyInteractionSource.reload();
            return;
          }
          this.historyInteractionSource.reset();
        })
      ),
    { dispatch: false }
  );

  constructor(
    private readonly actions$: Actions,
    private readonly historyContactSource: HistoryContactSource,
    private readonly historyInteractionSource: HistoryInteractionSource,
    private readonly router: HistoryRouter
  ) {
    super();
  }
}

@Injectable()
export class HistorySystemEffect extends CngBootstrapEffect {}
